import { SiteData } from 'pages/settings/sections/sites/SiteForm';
import { ACCOUNT_TYPE, SITE_TYPE } from 'pages/settings/sections/sites/types';

export const isSiteTypeSitesContainer = (siteType: SITE_TYPE) => {
  return siteType === SITE_TYPE.Account || siteType === SITE_TYPE.SiteManager;
};
export const isSiteUnderMsspAccount = (siteData: SiteData) => {
  return siteData.accountType === ACCOUNT_TYPE.Mssp && !isSiteTypeSitesContainer(siteData.type);
};
